export default "__VITE_ASSET__1de20700__"